import React, { useState } from "react";
import axios from "axios";
import { generalErrorAlert } from "../../../commons/GeneralErrorAlert";
import MainButtonComp from "../../../commons/Buttons/MainButtonComp";
import ContractFormModal from "./ContractFormModal";

/**
 * The "Edit" entry of the contracts table. The table rows carry no contract text, so the
 * full contract is loaded before the form opens.
 */
const UpdateContract = ({ contract, updateParent }) => {
  const [full, setFull] = useState(null);

  const open = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/contracts/contract/${contract._id}`,
        { headers: { Authorization: "Bearer " + localStorage.getItem("token") } }
      );
      setFull(res.data);
    } catch (err) {
      generalErrorAlert(err);
    }
  };

  return (
    <>
      <MainButtonComp text="Edit" editBtn onClick={open} />
      {full && (
        <ContractFormModal
          open
          contract={full}
          onClose={() => setFull(null)}
          onSaved={updateParent}
        />
      )}
    </>
  );
};

export default UpdateContract;
